import CancelIcon from '@mui/icons-material/Cancel';
import { PriorityHighRounded } from '@mui/icons-material';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Modal,
  Theme,
  Typography,
} from '@mui/material';
import { createStyles, makeStyles, useTheme } from '@mui/styles';
import { MESSAGES } from '../assets/messages';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      borderRadius: '20px !important',
      width: '50%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    cardHeader: {
      paddingBottom: '0 !important',
    },
    iconButton: {
      padding: '0px !important',
    },
    icon: {
      color: theme.palette.primary.main,
    },
    avatar: {
      padding: '0.5rem',
      marginBottom: '1rem',
      backgroundColor: `${theme.palette.error.main} !important`,
      width: '60px !important',
      height: '60px !important',
    },
    errorIcon: {
      color: 'white',
      fontSize: '60px !important',
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '0px !important',
    },
    errorText: {
      margin: 0,
      textAlign: 'center'
    },
  })
);

const ErrorModal = ({ error, onClose }: any) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Modal open={error.length > 0}>
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          action={
            <IconButton className={classes.iconButton} onClick={onClose}>
              <CancelIcon className={classes.icon} fontSize="large" />
            </IconButton>
          }
        />
        <CardContent className={classes.cardContent}>
          <Avatar className={classes.avatar}>
            <PriorityHighRounded className={classes.errorIcon} />
          </Avatar>

          <Typography component="h5" variant="h5">
            {MESSAGES['error']}
          </Typography>
          <Typography className={classes.errorText}>{error}</Typography>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default ErrorModal;
